import { gql } from "@apollo/client";
import { DEPOSIT_INFO } from "../fragments";

export const UPDATE_DEPOSIT_SETTING = gql`
  mutation updateDepositSetting($id: ID!, $input: DepositSettingInput!) {
    updateDepositSetting(id: $id, input: $input) {
      ...depositInfo
    }
  }
  ${DEPOSIT_INFO}
`;
